import styled from 'styled-components';

export const GroupStyled = styled.div`
  padding: 5px 0px;
`;
export const GroupHeadlineStyled = styled.div`
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
  padding: 5px 8px 5px 16px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const SingleValueStyled = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`;

export const OptionStyled = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: inherit;
  padding-left: 4px;
  ${({ isDisabled }) =>
    isDisabled &&
    `
    font-style: italic;
    color: var(
    --ds-soldevelo-select-option-disabled-font,
    var(--ds-fb-soldevelo-select-option-disabled-font)
  );
  `}
`;
